export enum ScheduledRequestType {
  addWeightMeasurement = 'addWeightMeasurement',
  setProfilePicture = 'setProfilePicture',
  setPregnancyStatus = 'setPregnancyStatus'
}

export interface ScheduledRequest<D> {
  id: string,
  type: ScheduledRequestType,
  numberOfAttempts?: number,
  data: D
}
